import en from './en'
import ja from './ja'
import zh from './zh'

export default { en, ja, zh }
